import { createRoot } from 'react-dom/client';
import { Root } from './routes/AppRoute';

const container = document.getElementById('root');

const root = createRoot(container!);

root.render(<Root />);
